import { useMutation, useQueryClient } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';

import { BaseError } from 'helpers/BaseError';

import { VariantBulkDelete } from 'models/variant.model';

import API from '../../services/api';

// queryKeys
import alternateKeys from '../alternates/_queryKeys';
import formulaKeys from '../formulas/_queryKeys';
import messageContentQueryKeys from '../message-content/_queryKey';
import useGetCurrentMessageContent from '../message-content/useGetCurrentMessageContent';

const useBulkDeleteVariantByComponentId = (
    componentId: string,
    formulaId: number,
) => {
    const queryClient = useQueryClient();
    const { currentMessageContentId } = useGetCurrentMessageContent(formulaId);
    const messageKey = formulaKeys.formulaMessages(
        formulaId,
        currentMessageContentId,
    );

    return useMutation<AxiosResponse, BaseError, VariantBulkDelete>({
        mutationFn: (data) =>
            API.bulkDeleteVariantByComponentId(componentId, data),

        onSettled: () => {
            if (componentId) {
                queryClient.invalidateQueries({
                    queryKey:
                        alternateKeys.getVariantsByComponentId(componentId),
                });
            }
            queryClient.invalidateQueries({
                queryKey: ['personalization-map'],
            });
            queryClient.invalidateQueries({
                queryKey: messageKey,
            });
            queryClient.invalidateQueries({
                queryKey: formulaKeys.formulaMessageCountUpdate(formulaId),
            });
            if (currentMessageContentId) {
                queryClient.invalidateQueries({
                    queryKey: alternateKeys.getVariantsByMessageContentId(
                        currentMessageContentId,
                    ),
                });
                queryClient.invalidateQueries({
                    queryKey: messageContentQueryKeys.messageContent(
                        currentMessageContentId,
                    ),
                });
            }
        },
    });
};

export default useBulkDeleteVariantByComponentId;
